module.exports = __webpack_public_path__ + "img/mobile/Background-freespins/fsbackground_portrait2@1x.jpg?1.0.17";